import { httpClient } from '@connectors/HttpClient'

import type { BillableAction, Creator } from '../types'

export type BillablesByItem = {
    [key: string]: BillableAction[]
}

export const BillableActionService = {
    listByCreator: async (creatorId: string): Promise<BillablesByItem> => {
        const response = await httpClient.axios.get(`/admin/billable-actions/creators/${creatorId}`)
        return response.data
    },
    getBilledCreators: async (): Promise<Creator[]> => {
        const response = await httpClient.axios.get(`/admin/billable-actions/creators`)
        return response.data
    },
    markBilled: async (creatorId: string): Promise<any> => {
        const response = await httpClient.axios.put(`/admin/billable-actions/creators/${creatorId}/mark-billed`)
        return response.data
    }
}
